import React, { FunctionComponent } from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { useAuthContext } from "../providers/Auth/auth.provider";
import { GroupType } from "../domain/group/group-type";
import { IUser } from "../domain/user/user";
import { isUserLoggedIn } from "./auth";
import { AvailableBaseRoutes } from "./constants";

interface IAuthenticatedRouteProps extends RouteProps {
  redirectTo?: string;
  allowedRoles?: GroupType[];
  allowedConditionCallback?: (user: IUser | undefined) => boolean;
}

export const AuthenticatedRoute: FunctionComponent<IAuthenticatedRouteProps> = (props) => {
  const { internalUser } = useAuthContext();
  const { redirectTo = AvailableBaseRoutes.Login, allowedRoles, allowedConditionCallback, location, ...rest } = props;
  if (!isUserLoggedIn()) {
    // Full relative URL, matching what the 401 interceptor stores, so the restored
    // location does not depend on which redirect happened to fire.
    const next = location ? `${location.pathname}${location.search}${location.hash}` : undefined;

    return <Redirect to={{ pathname: redirectTo, state: { next, nextOwner: internalUser?.email } }} />;
  }

  const isAllowed = () => {
    const notAllowed = internalUser && allowedRoles && !allowedRoles.some((role) => internalUser?.group?.type === role);
    const isAllowedConditionally = allowedConditionCallback ? allowedConditionCallback(internalUser) : false;
    // if user is allowed through condition; override notAllowed by roles
    return isAllowedConditionally ? isAllowedConditionally : !notAllowed;
  };

  return (
    <>
      {internalUser && (
        <>
          {!isAllowed() && <Redirect to={{ pathname: AvailableBaseRoutes.Login }} />}
          <Route {...rest} />
        </>
      )}
    </>
  );
};
